import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'tags-container',
  templateUrl: './tags-container.template.html',
  styleUrls: ['./tags-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsContainer extends StaticContainer {
  @Input() meta: any;
  @Input() default: any;
  
  ngOnInit() {
     this.default = this.coreEffects.getRouteDataAsObservable(this.route.snapshot.params);
     super.ngOnInit();
  }

  ngOnDestroy() {
//     if (this.coreEffects.tagSubscription){
//       this.coreEffects.tagSubscription.unsubscribe();
//     }
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/tags-container/tags-container.component.ts